
/**
 * Department must be one of the following:
 * 1. "MS"
 * 2. "ES"
 * 3. "HB"
 * 4. "MM"
 */
function sortDataByDepartment(data, department) {
    return data.filter(item => {
        if (Array.isArray(item.department)) {
            return item.department.includes(department);
        }
        return item.department === department;
    });
}

function sortDataByRole(data) {
    const topRoles = {
        "Team Leader": 1,
        "Chief Engineer": 2,
    };

    const departmentOrder = {
        "MM": 1,
        "ES": 2,
        "MS": 3,
        "HB": 4
    };

    const leaderRoles = [
        "Management & Marketing Leader",
        "Management & Marketing Technical Director",
        "Electrical Systems Leader",
        "Electrical Systems Technical Director",
        "Mechanical Systems Leader",
        "Mechanical Systems Technical Director",
        "Hull & Body Leader",
        "Hull & Body Technical Director",
        "Technical Director"
    ];

    const leaderRoleIndex = {};
    leaderRoles.forEach((role, index) => {
        leaderRoleIndex[role] = index;
    });

    return data.sort((a, b) => {
        const aTop = topRoles[a.role];
        const bTop = topRoles[b.role];

        if (aTop !== undefined && bTop !== undefined) {
            return aTop - bTop;
        }
        if (aTop !== undefined) return -1;
        if (bTop !== undefined) return 1;

        const aIsLeader = leaderRoleIndex[a.role] !== undefined;
        const bIsLeader = leaderRoleIndex[b.role] !== undefined;

        if (aIsLeader && bIsLeader) {
            return leaderRoleIndex[a.role] - leaderRoleIndex[b.role];
        }
        if (aIsLeader) return -1;
        if (bIsLeader) return 1;

        const roleCompare = a.role.localeCompare(b.role);
        if (roleCompare !== 0) return roleCompare;

        return a.name.localeCompare(b.name);
    });
}


function sortAlumni(data) {
    const topRoles = {
        "Team Leader": 1,
        "Chief Engineer": 2,
    };

    const leaderKeywords = ["Leader", "Technical Director", "Director"];

    return data.sort((a, b) => {
        const aTop = topRoles[a.role];
        const bTop = topRoles[b.role];

        if (aTop !== undefined && bTop !== undefined) {
            return aTop - bTop;
        }
        if (aTop !== undefined) return -1;
        if (bTop !== undefined) return 1;

        const aIsLeader = leaderKeywords.some(kw => a.role.includes(kw));
        const bIsLeader = leaderKeywords.some(kw => b.role.includes(kw));

        if (aIsLeader && bIsLeader) {
            return a.role.localeCompare(b.role);
        }
        if (aIsLeader) return -1;
        if (bIsLeader) return 1;

        const roleCompare = a.role.localeCompare(b.role);
        if (roleCompare !== 0) return roleCompare;

        return a.name.localeCompare(b.name);
    });
}


function sortMembers(data, department) {
    let filteredData;
    if (department === "Alumni") {
        filteredData = data.filter(item => item.department === "Alumni");
        return sortAlumni(filteredData);
    } else if (department?.trim()) {
        filteredData = sortDataByDepartment(data, department);
    } else {
        filteredData = data.filter(item => item.department !== "Alumni");
    }
    return sortDataByRole(filteredData);
}

export { sortDataByDepartment, sortDataByRole, sortMembers };
